export default __webpack_public_path__ + "static/media/maui.730d3b07.jpg";